import React, { useState } from "react";
import HotspotEditor from "./HotspotEditor";
import api from "../../../api";

const EditHotspotImage = ({
  chapterNumber,
  subchapterNumber,
  imageNumber,
  subchapter,
}) => {
  const [hotspots, setHotspots] = useState(subchapter.hotspots || []);
  const [saving, setSaving] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const handleHotspotsChange = (updatedHotspots) => {
    setHotspots(updatedHotspots);
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await api.put(
        `/api/admins/subchapter/{chapterNumber}/{subchapterNumber}/image-with-hotspots/{imageNumber}`,
        hotspots
      );
      alert("✅ Hotspots updated successfully!");
    } catch (err) {
      console.error("Error updating hotspots:", err);
      alert("❌ Failed to update hotspots!");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">
        Editing Hotspots for: {subchapter.subchapterTitle}
      </h2>

      <HotspotEditor
        imageUrl={`${BASE_URL}/${subchapter.content}`}
        hotspots={hotspots}
        onChange={handleHotspotsChange}
      />

      <button
        onClick={handleSave}
        disabled={saving}
        className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        {saving ? "Saving..." : "💾 Save Hotspots"}
      </button>
    </div>
  );
};

export default EditHotspotImage;
